import { render, staticRenderFns } from "./FreightComparisonTool.vue?vue&type=template&id=47547932&"
import script from "./FreightComparisonTool.vue?vue&type=script&lang=js&"
export * from "./FreightComparisonTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports